import { ChartSerializer } from "@models/serializers/chartSerializer"
import { httpRequest } from "@services/http"

/*
    One request serves the whole Monitor page: every chart the dashboard renders,
    scoped by the same filters. MPN-1530 adds the Date Filter's [start, end] to
    that scope, so the Performance Snapshot and all four tabs describe one span of
    days rather than each chart picking its own.

    The range is inclusive on both ends, matching the engagement_analytics SQL
    convention (utils/sql/date_window.py). Omitting either bound means all time,
    which is what the page did before this ticket and what "Since Campaign Start"
    falls back to when a campaign has nothing scheduled.
*/

const CHARTS = [
  "conversions-hud",
  "spend-hud",
  "revenue",
  "revenue-by-network",
  "revenue-by-day",
  "impressions-by-network",
  "conversions-by-day",
  "spend-by-network",
  "spend-conversions-by-day",
  "audience-by-network",
  "audience-network-counts",
  "budget-hud",
  "spend-by-ad-group",
  "conversions-by-journey-step",
  "revenue-by-journey-step",
  "last-file-load",
  "ad-performance",
  "engagements-by-network",
  "engagements-by-day",
  "campaign-dates",
  "performance-by-day",
  "spend-panels",
  "audience-breakdown",
  "ad-schedule-spans",
  "ad-flight-conversions",
  "key-dates",
  "conversions-by-day-by-step",
]

export type AnalyticsScope = {
  objectiveId?: number
  audienceId?: number
  launchId?: number
  /** Inclusive yyyy-mm-dd. Omit for all time. */
  start?: string
  end?: string
}

export class CommandGetEngagementAnalytics {
  async run(engagementId: number, scope: AnalyticsScope = {}) {
    const params = new URLSearchParams({ charts: CHARTS.join(",") })
    if (scope.objectiveId !== undefined) params.set("objective_id", String(scope.objectiveId))
    if (scope.audienceId !== undefined) params.set("audience_id", String(scope.audienceId))
    if (scope.launchId !== undefined) params.set("launch_id", String(scope.launchId))
    if (scope.start) params.set("start", scope.start)
    if (scope.end) params.set("end", scope.end)

    const url = `${
      import.meta.env.VITE_API_PLATFORM_SERVICE_URL
    }api/v1/engagements/${engagementId}/analytics/?${params.toString()}`

    try {
      const response = await httpRequest<any>(url, { method: "GET" })
      return this.deserialize(response)
    } catch (error) {
      console.error("Error fetching data:", error)
      throw error
    }
  }

  deserialize(data: any): any {
    const serializer = new ChartSerializer()
    return serializer.deserialize(data)
  }
}
